import { StatusStyleCode } from '../common'
import { ApiEntityStatus } from './common.types'

export enum SaleOrderStatusCode {
    New = '-2', // new
    Work = '0', // work
    Completed = '2', //completed
}

export const SaleOrderStatusSpec: { [key in SaleOrderStatusCode]: Omit<ApiEntityStatus, 'code'> } = {
    [SaleOrderStatusCode.New]: { id: -2, name: 'Новый', color: StatusStyleCode.Blue },
    [SaleOrderStatusCode.Work]: { id: 0, name: 'В работе', color: StatusStyleCode.Yellow },
    [SaleOrderStatusCode.Completed]: { id: 2, name: 'Завершен', color: StatusStyleCode.Green },
}